import React, { useState } from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Input, LinearProgress, Text } from '@rneui/themed';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import zxcvbn from 'zxcvbn';

const PasswordInput = ({
  placeholder,
  errorMessage,
  value,
  onChangeText,
  iconColor = 'white',
  showStrength = false,
  ...props
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(null);

  const strangthColors = ['red', 'orange', 'orange', 'green', 'green'];
  const strengthTexts = [
    'very-weak',
    'weak',
    'medium',
    'strong',
    'very-strong',
  ];

  const handlePasswordChange = (text) => {
    onChangeText(text);
    const result = zxcvbn(text);
    setPasswordStrength(result?.score); // Score is 0 to 4
  };

  return (
    <View>
      <Input
        placeholder={placeholder}
        placeholderTextColor="lightgrey"
        secureTextEntry={!showPassword}
        onChangeText={handlePasswordChange}
        value={value}
        errorMessage={errorMessage}
        rightIcon={
          <MaterialCommunityIcons
            name={showPassword ? 'eye' : 'eye-off'}
            size={20}
            color={iconColor}
            onPress={() => {
              setShowPassword(!showPassword);
            }}
          />
        }
        {...props}
      />
      {showStrength && value?.length >= 6 && (
        <>
          <LinearProgress
            style={{ marginVertical: 10 }}
            variant="determinate"
            value={(passwordStrength + 1) / 5.0}
            color={strangthColors[passwordStrength]}
          />
          <Text style={{ fontSize: 12 }}>
            {t('password.strengthText.' + strengthTexts[passwordStrength])}
          </Text>
        </>
      )}
    </View>
  );
};

export default PasswordInput;
